import { defineMessages } from 'react-intl.macro';

export default defineMessages({
    header: {
        id: 'class-roster-table.header',
        defaultMessage: 'Classroom access',
    },
});
